<template>
    <div class="prev-next-well-buttons">
        <b-button
            variant="primary"
            :disabled="isFirstWell"
            :title="$translate('previous_well')"
            @click="selectWell(false)"
        >
            <i class="fa fa-chevron-left" />
        </b-button>

        <b-button
            variant="primary"
            :disabled="isLastWell"
            :title="$translate('next_well')"
            @click="selectWell(true)"
        >
            <i class="fa fa-chevron-right" />
        </b-button>
    </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
    name: 'PrevNextWellButtons',
    computed: {
        ...mapState({
            selectedTreatment: state => state.timelapse.selectedTreatment,
            focusedWell: state => state.timelapse.focusedWell
        }),
        wells() {
            return this.selectedTreatment ? this.selectedTreatment.wellsByIndex : []
        },
        index() {
            if (!this.focusedWell) return null

            return this.wells.findIndex(well => well._id === this.focusedWell._id)
        },
        isFirstWell() {
            return this.index === 0
        },
        isLastWell() {
            return this.index === this.wells.length - 1
        }
    },
    methods: {
        selectWell(next) {
            this.$log.actionEvent('prev_next_well')

            const desiredIndex = this.index + (next ? 1 : -1)

            this.$mainController.selectWell(this.wells[desiredIndex])
        }
    }
}
</script>

<style lang="scss" scoped>
.prev-next-well-buttons {
    padding: 1rem;
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    border-bottom-left-radius: $border-radius-lg;
    border-bottom-right-radius: $border-radius-lg;

    .fa-chevron-left,
    .fa-chevron-right {
        position: relative;
    }

    .fa-chevron-left {
        right: 2px;
    }
    .fa-chevron-right {
        left: 2px;
    }

    @media screen and #{$new-break3close} {
        justify-content: center;
        background-color: $dark-4;

        button:first-child {
            margin-right: 100px;
        }
    }
    @media screen and #{$new-break4open} {
        button:first-child {
            margin-right: 1rem;
        }
    }
    @media screen and #{$new-break4} {
        padding: 0.5rem 1rem;
    }
}
</style>
